import { useFocusTabStore } from '../../../../../store/strategy-store/strategy-store';
import { setFocusSelectedTeams } from '../../../../../store/strategy-store/strategy-store.actions';
import { FiltersListTeams } from '../../components/filters-list/filters-list-teams';
import { useContributingTeams } from '../../initiative-performance.hooks';

export const FiltersTeams = () => {
  const contributingTeams = useContributingTeams();
  const selectedTeams = useFocusTabStore((state) => state.selectedTeams);

  return (
    <FiltersListTeams teams={contributingTeams} selectedTeams={selectedTeams} onSelectTeams={setFocusSelectedTeams} />
  );
};
